import { render, staticRenderFns } from "./App.vue?vue&type=template&id=47df9f5c"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=47df9f5c&prod&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports